import { render, staticRenderFns } from "./OrderStatusOverview.vue?vue&type=template&id=51a96161&scoped=true"
import script from "./OrderStatusOverview.vue?vue&type=script&lang=js"
export * from "./OrderStatusOverview.vue?vue&type=script&lang=js"
import style0 from "./OrderStatusOverview.vue?vue&type=style&index=0&id=51a96161&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a96161",
  null
  
)

export default component.exports